export const REGEX = {
  FIRST_NAME_LAST_NAME: /^([A-Za-z]+\s)*[A-Za-z]+$/,
  // FIRST_NAME_LAST_NAME: /^[A-Za-z]+(?: +[A-Za-z]+)*$/,
  PHONE_NUMBER: /^(\d{3})[-]{1}(\d{4})$/,
  PHONE_NUMBER_AREA_CODE: /^([2-9][0-9]{2})$/,
  NUMBERS: /^-?[\d.]+(?:e-?\d+)?$/,
  CITY: /^[A-Za-z" "-]+$/,
  DBA: /^[A-Za-z-0-9]+(?: +[A-Za-z]+)*$/,
  // USD: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/,
  USD:/^[0-9.]+$/,
  // SSN: /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/,
  // SSN:/^[0-9-]+$/,
  ZIP_CODE: /^[0-9]{5}(?:-[0-9]{4})?$/,
  EMAIL_ADDRESS: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/,
  DATE: /(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](18|19|20)\d\d/,
  ADDRESS_BETA: /^[^~`<>%$*_{}\[\]&]*$/,
  newDBA: /[^0-9]*[a-zA-Z_ ]+[a-zA-Z._^%$#!~@,-]/,
  TAX_EXEMP_NUM:/^[A-Za-z0-9-]+$/,
  DNB_NUM: /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/
};
